export default function Products() {
  const products = [
    {
      name: 'VPN',
      category: 'SECURITY',
      description: 'Secure and fast VPN service protecting your online privacy with military-grade encryption',
      image: 'https://public.readdy.ai/ai/img_res/77093b20db674b15a4baabd5e3626e88.jpg'
    },
    {
      name: 'Cleaner',
      category: 'UTILITY',
      description: 'Powerful cleaning tool to optimize your device performance and free up storage space',
      image: 'https://readdy.ai/api/search-image?query=iOS%20cleaner%20utility%20app%20interface%20displaying%20storage%20optimization%20dashboard%20with%20colorful%20charts%20and%20clean%20button%2C%20modern%20minimalist%20design%20with%20white%20and%20teal%20accents%2C%20iPhone%20mockup%20showing%20file%20management%20and%20memory%20cleanup%20features%20on%20light%20beige%20background%2C%20professional%20app%20screenshot%20photography&width=380&height=440&seq=product-cleaner-002&orientation=portrait'
    },
    {
      name: 'Security Suite',
      category: 'PROTECTION',
      description: 'Comprehensive security solution with real-time threat detection and privacy protection',
      image: 'https://readdy.ai/api/search-image?query=Mobile%20security%20app%20interface%20on%20iPhone%20showing%20protection%20dashboard%20with%20lock%20icons%20and%20security%20status%20indicators%2C%20sleek%20dark%20mode%20UI%20with%20teal%20highlights%2C%20professional%20iOS%20app%20design%20displaying%20threat%20detection%20and%20privacy%20features%20on%20light%20beige%20background%2C%20high%20quality%20product%20mockup&width=380&height=440&seq=product-security-003&orientation=portrait'
    },
    {
      name: 'Performance Optimizer',
      category: 'OPTIMIZATION',
      description: 'Advanced optimization tools to boost device speed and extend battery life',
      image: 'https://readdy.ai/api/search-image?query=iOS%20performance%20optimizer%20app%20showing%20speed%20gauge%20and%20battery%20optimization%20interface%2C%20modern%20clean%20design%20with%20gradient%20backgrounds%20and%20performance%20metrics%2C%20iPhone%20screen%20displaying%20system%20monitoring%20and%20boost%20features%20on%20light%20beige%20background%2C%20professional%20mobile%20app%20photography&width=380&height=440&seq=product-optimizer-004&orientation=portrait'
    }
  ];

  return (
    <section id="products" className="py-32 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-start justify-between mb-20">
          <div>
            <span className="inline-block px-4 py-2 border border-white/30 text-white text-xs font-semibold uppercase tracking-widest rounded-full">
              PRODUCTS
            </span>
          </div>
          <div className="max-w-2xl">
            <h2 className="text-6xl font-extrabold text-white text-right leading-tight">
              Premium iOS Solutions
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="bg-[#F7F3EE] rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 mb-6">
                <div className="w-full h-96 flex items-center justify-center p-8">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top rounded-lg"
                  />
                </div>
              </div>
              <div className="px-2">
                <h3 className="text-2xl font-semibold text-white mb-2">{product.name}</h3>
                <p className="text-sm text-[#A0A0A0] uppercase tracking-wide mb-3">{product.category}</p>
                <p className="text-base text-[#808080] leading-relaxed line-clamp-2">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
